import { IGetBookingsCommonResponse } from "../booking/interfaces/IGetBookings";


export enum TaskStatus {
    Pending = 'pending',
    Error = 'error',
    Success = 'success',
    Processing = 'processing',
    Warning = 'warning',
}

export interface ITask {
    id: number;
    status: TaskStatus;
    message: string;
    whenLastUpdated: string;
    booking: IGetBookingsCommonResponse;
    response?: ITaskResponse;
}

/**
 * This interface is meant to be extended by processing services.
 * Its subclasses will contain detailled processing result data.
 */
export interface ITaskResponse {
}
